import { ReactNode, useId } from 'react';

import FacialHair from './facialHair';
import HairColor from './HairColor';

const LongHairNotTooLong = ({ children }: { children: ReactNode }) => {
  const uniqueId = useId();
  const mask1 = `${uniqueId}-mask1`;
  const mask2 = `${uniqueId}-mask2`;
  const path1 = `${uniqueId}-path1`;
  const path2 = `${uniqueId}-path2`;

  return (
    <g id="Top" strokeWidth="1" fillRule="evenodd">
      <defs>
        <rect id={path1} x="0" y="0" width="264" height="280" />
        <path
          d="M59,102.340285 C59,118.921045 59,145.474283 59,182 C59,186.418278 62.581722,190 67,190 L109,190 L109,180.610951 C91.4692178,172.282984 78.9518066,155.114792 77.2085808,134.867187 C71.4308707,134.002364 67,129.018625 67,123 L67,110 C67,106.509412 68.4903619,103.366917 70.8694649,101.174135 C82.4088376,98.5552525 94.9706808,93.6376395 107.341516,86.4953343 C119.473269,79.4910638 129.843979,71.2579416 137.820938,62.752196 C134.394107,70.6604321 130.244513,77.5880409 125.372156,83.5350224 C138.047336,78.0120855 146.677812,69.1324394 151.263585,56.8960843 C151.64142,57.8180234 152.034942,58.738913 152.444252,59.6582378 C162.699828,82.6926393 180.317578,99.018563 198.205873,104.403108 C198.718861,106.513486 199,108.48395 199,110 L199,123 C199,129.018625 194.569129,134.002364 188.791419,134.867187 C187.048193,155.114792 174.530782,172.282984 157,180.610951 L157,190 L175,190 C192.673112,190 207,175.673112 207,158 C207,133.944314 207,115.902549 207,103.874706 C207,103.807916 206.990567,103.721208 206.971823,103.615272 C206.82774,91.3536714 206.623862,84.2237818 206.360189,82.2256031 C201.576875,45.9764505 170.555563,18 133,18 C96.9151011,18 66.8627142,43.8282542 60,78 C54.4771525,78 50,83.5964406 50,90.5 C50,95.0507583 51.6949619,99.1431718 54.8534901,101.273154 C55.7582038,101.883256 57.323834,102.197638 58.9999994,102.340287 Z"
          id={path2}
        />
      </defs>
      <mask id={mask1} fill="white">
        <use xlinkHref={'#' + path1} />
      </mask>
      <g id="Mask" />
      <g id="Top/Long-Hair/Long-but-not-too-long" mask={`url(#${mask1})`}>
        <g transform="translate(-1.000000, 0.000000)">
          <g id="Behind" strokeWidth="1" fillRule="evenodd">
            <mask id={mask2} fill="white">
              <use xlinkHref={'#' + path2} />
            </mask>
            <use id="Combined-Shape" fill="#944F23" xlinkHref={'#' + path2} />
            <HairColor maskID={mask2} />
          </g>
          <g
            id="Top"
            opacity="0.439990942"
            strokeWidth="1"
            fillRule="evenodd"
            transform="translate(50.000000, 18.000000)"
            fillOpacity="0.159999996"
          >
            <path
              d="M11.8989604,84.7749122 C25.7109099,83.0145308 41.6792969,77.5379209 57.3415164,68.4953343 C69.4732686,61.4910638 79.8439791,53.2579416 87.8209384,44.752196 C84.3941075,52.6604321 80.2445133,59.5880409 75.3721558,65.5350224 C88.0473359,60.0120855 96.6778122,51.1324394 101.263585,38.8960843 C101.64142,39.8180234 102.034942,40.738913 102.444252,41.6582378 C114.38223,68.4713761 136.296003,86.1944823 157,88.1510343 L157,88.1510343 L157,74 C157,33.1309285 123.869071,-7.50752664e-15 83,0 C46.9151011,6.62868839e-15 16.8627142,25.8282542 10.3212729,60.0063288 C10.214595,60.0021202 10.1074956,60 10,60 C4.4771525,60 0,65.5964406 0,72.5 C0,78.9816827 3.9466744,84.3111215 8.99999442,84.9382803 L8.99999434,85.0927525 C9.31629342,85.0638362 9.63387297,85.0328725 9.95270131,84.9998631 C9.96845895,84.9999543 9.98422521,85 10,85 C10.6492988,85 11.2841443,84.9226474 11.8989604,84.7749122 Z"
              id="Combined-Shape"
              fill="#FFFFFF"
            />
          </g>
          <FacialHair />
          {children}
        </g>
      </g>
    </g>
  );
};

LongHairNotTooLong.displayName = 'LongHairNotTooLong';
export default LongHairNotTooLong;
